import {axios} from "../axios"

interface APIResponse {
    data: any;
}


export const SiloGroupAPI = {
 async getSiloConfiguration(device_pk: number | string): Promise<any> {
        const { data } = await axios.get<APIResponse>(
            `api/v1/silo_groups/${device_pk}/`
        );
        return data;
    },

    async saveSiloConfiguration(device_pk: number | string, payload: any): Promise<any> {

        const { data } = await axios.post<APIResponse>(
            `api/v1/silo_groups/${device_pk}/`,
            payload
        );

        return data;
    },

     async getSiloGroupTypes(): Promise<any> {
        const data = await axios.get<APIResponse>(`api/v1/silo_group_types/`);

        return data;
    },
}